// @link https://nuxtjs.org/docs/configuration-glossary/configuration-router/#scrollbehavior
export default function (/*to, from, savedPosition*/) {
  return { x: 0, y: 0 }
}
